const baseOrderedListData = { indentation: 0 };
const OrderedListData = {
  fromJSON(object) {
    const message = { ...baseOrderedListData };
    message.indentation = object.indentation !== void 0 && object.indentation !== null ? Number(object.indentation) : 0;
    message.offset = object.offset !== void 0 && object.offset !== null ? Number(object.offset) : void 0;
    message.start = object.start !== void 0 && object.start !== null ? Number(object.start) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.indentation !== void 0 && (obj.indentation = Math.round(message.indentation));
    message.offset !== void 0 && (obj.offset = message.offset);
    message.start !== void 0 && (obj.start = message.start);
    return obj;
  }
};
const baseBulletedListData = { indentation: 0 };
const BulletedListData = {
  fromJSON(object) {
    const message = { ...baseBulletedListData };
    message.indentation = object.indentation !== void 0 && object.indentation !== null ? Number(object.indentation) : 0;
    message.offset = object.offset !== void 0 && object.offset !== null ? Number(object.offset) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.indentation !== void 0 && (obj.indentation = Math.round(message.indentation));
    message.offset !== void 0 && (obj.offset = message.offset);
    return obj;
  }
};
export {
  BulletedListData,
  OrderedListData
};
//# sourceMappingURL=node_list.js.map
